<ng-content></ng-content>

<div class="menu-container">
  <dx-tree-view
    class="treeView"
    [items]="items"
    keyExpr="path"
    selectionMode="single"
    [focusStateEnabled]="false"
    expandEvent="click"
    (onItemClick)="onItemClick($event)"
    width="100%"
    margin-left="10px"
  >
  </dx-tree-view>
</div>
